<template>
  <div class="ApplyInvoice">
  	<meta name="description" content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"/>
		<title>发票申请-以诺教育</title>
  	<headTop></headTop>
    <Breadcrumb class="zhCrumbs"  separator="<span class='demo-breadcrumb-separator'>></span>">
      <BreadcrumbItem href="/orderList">个人中心</BreadcrumbItem>
      <BreadcrumbItem href="/orderList">订单中心</BreadcrumbItem>
      <BreadcrumbItem style="color:#909090;font-weight: normal;">申请发票</BreadcrumbItem>
    </Breadcrumb>
    <!--<div class="zhCrumbs">  个人中心  >  订单中心  >  <span>申请发票</span></div>-->
    <div class="zhModule1">
      <div class="zhInformation">
        <p class="zhCode">订单编号：<span>{{zhCode}}</span></p>
        <p class="zhCode">实付金额：¥{{zhPir}} <i>发票金额不包含奖学金等优惠部分</i></p>
      </div>
      <div class="zhConfirm">
        <p class="zhInvoice">确认发票信息 <span>个人发票不需要填写“纳税人识别号”</span></p>
        <div class="zhInvoiceType">
          <span class="zhType">发票类型</span>
          <span class="zhBottom zhAction"><span class="zhYuan" v-if="zhhide"></span></span>
          <span class="zhWorder">增值税普通发票</span>
          <span class="zhBottom zhBottom1"><span class="zhYuan" v-if="!zhhide"></span></span>
          <span class="zhWorder">增值税专用发票</span>
        </div>

        <div class="zhContent" v-if="zhhide">
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 发票抬头</span>
            <input type="text" class="zhInvoiceContent" placeholder="发票抬头" :value="zhList.title"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType">税号</span>
            <input type="text" class="zhInvoiceContent1" placeholder="纳税人识别号" :value="zhList.code"/><i class="zherror"></i>
          </div>
        </div>

        <div class="zhContent" v-if="!zhhide">
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 发票抬头</span>
            <input type="text" class="zhInvoiceContent" placeholder="发票抬头" :value="zhList.title"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 税号</span>
            <input type="text" class="zhInvoiceContent" placeholder="纳税人识别号" :value="zhList.code"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 开户行</span>
            <input type="text" class="zhInvoiceContent" placeholder="开户银行名称" :value="zhList.bank_name"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 账号</span>
            <input type="text" class="zhInvoiceContent" placeholder="单位银行账号" :value="zhList.bank_code"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 地址</span>
            <input type="text" class="zhInvoiceContent" placeholder="单位税务备案地址" :value="zhList.address"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 电话</span>
            <input type="text" class="zhInvoiceContent zphone1" placeholder="单位电话号码" :value="zhList.mobile"/><i class="zherror"></i>
          </div>
        </div>

        <p class="zhInvoice">收件人信息 <span>我们会尽快将发票寄送至收件地址，请完整填写</span></p>
        <div class="zhAddressee">
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 收件人</span>
            <input type="text" class="zhInvoiceContent" placeholder="收件人姓名" :value="zhList.recipients_name"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 所在地区</span>
            <div class="zhCascader">
              <Cascader :data="options" :render-format="format"></Cascader>
            </div>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 详细地址</span>
            <input type="text" class="zhInvoiceContent" placeholder="发票寄送地址" :value="zhList.mailing_address"/><i class="zherror"></i>
          </div>
          <div class="zhContentss">
            <span class="zhType"><i>*</i> 手机</span>
            <input type="text" class="zhInvoiceContent zphone" placeholder="收件人手机号码" :value="zhList.recipients_mobile"  /><i class="zherror"></i>
          </div>
        </div>

        <div class="zhSubmit">申请发票</div>
      </div>
    </div>
    <!--弹框-->
    <div class="zhTan" v-show="zhTrue">
      <div class="zhBlock">
          <div class="zhBlockTop">提示<Icon type="close" class="zhIcon"></Icon></div>
         <div class="zhTishi">发票信息提交成功，我们将尽快完成开票并邮寄</div>
        <div class="zhQue">
          <div class="zhDetermine"><router-link to="/orderList" class="zhQueDing">确定</router-link></div>
          <!--<div class="zhDetermine1">取消</div>-->
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
	import headTop from "../headTop/headTop"
  import Bottom from "../Bottom/Bottom"
  export default {
    name:"ApplyInvoice",
    components:{headTop,Bottom},
    data(){
      return{
        zhhide:true,
        options:[],
        zhCode:this.$route.params.id,
        zhPir:'',
        zhList:{},
        zhPD:true,
        zhTrue:false,
      }
    },
    methods:{

      format (labels, selectedData){
        const index = labels.length - 1;
        const data = selectedData[index] || false;
        var aaa = labels[0];
        if (data) {
          for(var i=1;i<index+1;i++){
            aaa = aaa+ labels[i];
          }
          return aaa;
        }
        return aaa;
      }
    },
     mounted(){
    var that = this;
    $(".zhBottom").on("click",function(){
      $(".zhBottom").removeClass("zhAction");
      $(this).addClass("zhAction");
      $(".zhBottom").css({"border":"2px solid #dfdfdf"});
      $(this).css({"border":"2px solid #27cb9a"});
      if($(this).index()==1){
        that.zhhide = true;
        that.$ajax({
          method:"post",
          url:"/api/default_invoice",
          data:{
            "type":1
          },
        })
          .then(function(data){
            that.zhList = data.data.result;
            $(".ivu-cascader .ivu-input").val(that.zhList.mailing_area);
          })
      }else if($(this).index()==3){
        that.zhhide = false;
        //默认发票
        that.$ajax({
          method:"post",
          url:"/api/default_invoice",
          data:{
            "type":2
          },
        })
          .then(function(data){
            that.zhList = data.data.result;
            $(".ivu-cascader .ivu-input").val(that.zhList.mailing_area);
          })
      }
    })
    $(".zhIcon").on("click",function(){
      $(".zhIcon").toggleClass("ZhAct")
    })
    //验证
    $(document).on('change','.zhInvoiceContent',function(){
      if($(this).val()===''){
        $(this).next().html('*内容不能为空！');
        that.zhPD = false;
        return false;
      }else{
        $(this).next().html('');
        that.zhPD = true;
      }
    })
    $(document).on('change','.zphone',function(){
      if(!(/^1[34578]\d{9}$/.test($(this).val()))){
        $(this).next().html('*手机号码有误，请重填！');
        that.zhPD = false;
        return false;
      }else{
        $(this).next().html('');
        that.zhPD = true;
      }
      })
      $(document).on('change','.zphone1',function(){
      if(!(/^([0-9]{3,4}-)?[0-9]{7,8}$/.test($(this).val()))){
        $(this).next().html('*手机号码有误，请重填！');
        that.zhPD = false;
        return false;
      }else{
        $(this).next().html('');
        that.zhPD = true;
      }
    })
    //初始化 地址
    that.$ajax({
      method:"post",
      url:"/api/get_area",
    }).then(function(data){
      that.options = data.data.result;
    }).catch(function(err){
      console.log(err)
    })
    $(".ivu-cascader-rel").on("click",function(){
      $(".ivu-cascader .ivu-input").css({"box-shadow": "none",})
    })
    //初始
      that.$ajax({
        method:"post",
        url:"/api/MyOrderDetail",
        data:{
          "id":that.zhCode
        },
      })
      .then(function(data){
        that.zhPir = data.data.result[0].unit_price;
      })
    //默认发票
    that.$ajax({
      method:"post",
      url:"/api/default_invoice",
      data:{
        "type":1
      },
    })
      .then(function(data){
        that.zhList = data.data.result;
        $(".ivu-cascader .ivu-input").val(that.zhList.mailing_area);
      })
    //申请发票
    $(".zhSubmit").on("click",function(){
      if(that.zhhide == true){
        if(that.zhPD == false){
          alert("请填写完整信息")
        }else{
          that.$ajax({
            method: "post",
            url: "/api/invoice",
            data: {
              "order_id": that.zhCode,
              "type": 1,
              "code": $(".zhContent").eq(0).children().children("input").eq(1).val(),
              "title": $(".zhContent").eq(0).children().children("input").eq(0).val(),
              "recipients_name": $(".zhAddressee").eq(0).children().children("input").eq(0).val(),
              "mailing_area": $(".ivu-cascader .ivu-input").val() ,
              "mailing_address": $(".zhAddressee").eq(0).children().children("input").eq(1).val(),
              "recipients_mobile": $(".zhAddressee").eq(0).children().children("input").eq(2).val(),
              "bank_name": "",
              "bank_code": "",
              "address": "",
              "mobile": "",
            },
          })
            .then(function (data) {
              if(data.data.result.msg=='发票信息保存成功'){
                that.zhTrue = true;
              }else{
                that.zhTrue = false;
                alert("请填写完整信息");
              }
            })
        }
      }else{
        for(let i=0;i<$(".zhInvoiceContent").length;i++) {
          if ($(".zhInvoiceContent").eq(i).val() == '')
          {
            that.zhPD = false;
          }
        }
        if(that.zhPD == false){
          alert("请填写完整信息")
        }else{
          that.$ajax({
            method:"post",
            url:"/api/invoice",
            data:{
              "order_id": that.zhCode,
              "type": 2,
              "code": $(".zhContent").eq(0).children().children("input").eq(1).val(),
              "title": $(".zhContent").eq(0).children().children("input").eq(0).val(),
              "recipients_name": $(".zhAddressee").eq(0).children().children("input").eq(0).val(),
              "mailing_area": $(".ivu-cascader .ivu-input").val() ,
              "mailing_address": $(".zhAddressee").eq(0).children().children("input").eq(1).val(),
              "recipients_mobile": $(".zhAddressee").eq(0).children().children("input").eq(2).val(),
              "bank_name":$(".zhContent").eq(0).children().children("input").eq(2).val(),
              "bank_code":$(".zhContent").eq(0).children().children("input").eq(3).val(),
              "address":$(".zhContent").eq(0).children().children("input").eq(4).val(),
              "mobile":$(".zhContent").eq(0).children().children("input").eq(5).val(),
            },
          })
            .then(function(data){
              if(data.data.result.msg=='发票信息保存成功'){
                that.zhTrue = true;
              }else{
                that.zhTrue = false;
                alert("请填写完整信息")
              }
            })
        }

      }
    })
    //关闭
    $(".zhIcon").on("click",function(){
      that.zhTrue = false;
    })
  },
  }
</script>

<style>
  .ApplyInvoice{width:100%;background:#f4f5f9;}
  .ApplyInvoice .zhCrumbs{color:#4f4f4f;font-size:14px;box-sizing: border-box;padding:30px 0 20px;width:960px;margin:0 auto;}
  .ApplyInvoice .zhCrumbs>span{color:#909090;}
  .ApplyInvoice .zhModule1{width:960px;background:#ffffff;box-shadow:0 0 15px rgba(0,0,0,.08);margin:0 auto 265px; }
  .ApplyInvoice .zhInformation{width:100%;height:103px;box-sizing: border-box;border-bottom: 1px solid #e6e6e6;padding:20px 30px;}
  .ApplyInvoice .zhCode{font-size: 14px;color:#909090;height:32px;line-height:32px;}
  .ApplyInvoice .zhCode>span{color:#01b784;}
  .ApplyInvoice .zhCode>i{color:#ff5050;font-size: 12px;margin-left:20px;font-style:normal;}
  .ApplyInvoice .zhConfirm{width:100%;padding:30px 40px;margin-bottom:30px;}
  .ApplyInvoice .zhInvoice{font-size:18px;color:#4f4f4f;padding-bottom:31px;font-weight: bold;}
  .ApplyInvoice .zhInvoice>span{font-size:12px;color:#909090;margin-left:15px;font-weight: normal;}
  .ApplyInvoice .zhInvoiceType{width:100%;position:relative;padding:15px 0;}
  .ApplyInvoice .zhType{width:90px;text-align: right;font-size:14px;color:#4f4f4f;display: inline-block;}
  .ApplyInvoice .zhBottom{cursor:pointer;position:absolute;bottom:15px;;left:110px;;display: inline-block;width:18px;height:18px;border-radius: 50%;box-sizing: border-box;border:2px solid #dfdfdf;}
  .ApplyInvoice .zhYuan{display: inline-block;width:10px;height:10px;border-radius: 50%;position: absolute;top:15%;left:15%;;background: #27cb9a;}
  .ApplyInvoice .zhBottom1{left:256px;}
  .ApplyInvoice .zhWorder{font-size:14px;color:#4f4f4f;margin-left:48px;}
  .ApplyInvoice .zhType>i{font-style:normal;font-size:14px;color:#ff5050;}
  .ApplyInvoice .zhContent{padding-bottom:51px;}
  .ApplyInvoice .zhContentss{width:100%;padding:9px 0;position:relative;}
  .ApplyInvoice .zhInvoiceContent{margin-left:20px;width:200px;height:33px;border:1px solid #dfdfdf;padding-left:10px;}
  .ApplyInvoice .zhInvoiceContent1{margin-left:20px;width:200px;height:33px;border:1px solid #dfdfdf;padding-left:10px;}
  .ApplyInvoice .zhSubmit{cursor:pointer;width:160px;height:40px;background:#27cb9a;font-size: 14px;color:#ffffff;font-weight: bold;margin:21px 0 0 110px;text-align: center;line-height: 40px;border-radius: 5px;}
  .ApplyInvoice .zhAction{border:2px solid #27cb9a}
  .ApplyInvoice .zhCascader{display:inline-block;width:200px;height:33px;margin-left:20px;}
  .ApplyInvoice .ivu-cascader .ivu-input{border:1px solid #dfdfdf;padding-left:10px;border-radius: 0;}
  input::-webkit-input-placeholder {color: #bbbbbb;}
  .ApplyInvoice .zherror{color:#ff5050;margin-left:10px;font-style:normal;}
  .ApplyInvoice .zhTan{width:100%;height:100%;position: fixed;top:0;left:0;background: rgba(0,0,0,.5);display: flex;justify-content: center;align-items: center;}
  .ApplyInvoice .zhBlock{width:360px;height:220px;background: #ffffff;}
  .ApplyInvoice .zhBlockTop{width:100%;height:50px;border-bottom: 1px solid #e6e6e6;box-sizing: border-box;padding:0 20px;font-size: 16px;color:#4f4f4f;font-weight:600;display: flex;justify-content: space-between;align-items: center;}
  .ApplyInvoice .zhIcon{font-size:20px;color:#90908f;font-weight: normal;cursor: pointer;}
  .ApplyInvoice .zhTishi{width:100%;height:95px;font-size: 16px;color:#4f4f4f;display: flex;justify-content: center;align-items: center;padding:0 20px;}
  .ApplyInvoice .zhQue{width:100%;box-sizing: border-box;padding:0 56px;display: flex;justify-content: space-around;}
  .ApplyInvoice .zhDetermine{width:110px;height:36px;background: #00b983;border-radius: 7px;display: flex;justify-content: center;align-items: center;font-size:14px;color:#ffffff;cursor: pointer;}
  .ApplyInvoice .zhDetermine1{width:110px;height:36px;background: #dddddd;border-radius: 5px;display: flex;justify-content: center;align-items: center;font-size:14px;color:#909090;cursor: pointer;}
  a{color:#ffffff;}
  .zhQueDing{color:#ffffff;}
  /*面包屑*/
  .ApplyInvoice  .demo-breadcrumb-separator{color: #495060;padding: 0 5px; }
  .ApplyInvoice  a:hover{color:#4f4f4f;}
</style>



// WEBPACK FOOTER //
// ApplyInvoice.vue?69f327fc